module.exports = __webpack_public_path__ + "img/sus_no.a56e873f.png";